import moment from "moment";

export default function getDateRenouvel(dateDepot, nbRenouvel) {
    return moment(dateDepot).startOf("day").add((nbRenouvel + 1) * 10, "y")
}
